import { Link } from 'react-router-dom';

export function About() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-neutral-400 hover:text-white text-sm mb-8 transition-colors"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back to search
      </Link>

      <h1 className="font-mono text-3xl sm:text-4xl font-bold text-white mb-8">
        About NFA
      </h1>

      <div className="prose prose-invert prose-neutral max-w-none space-y-8">
        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">The Problem</h2>
          <p className="text-neutral-300 leading-relaxed">
            Every gear recommendation site is either a thinly-veiled affiliate farm with "Top 10"
            lists that feature whoever pays the most, or an overwhelming wiki that expects you to
            become an expert before buying anything.
          </p>
          <p className="text-neutral-400 mt-4">
            You just want to know what to pack for your trip. Not 47 options. Not a quiz.
            Not sponsored content dressed up as advice.
          </p>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">The Solution</h2>
          <p className="text-neutral-300 leading-relaxed">
            NFA (Not Fucking About) gives you a single, opinionated gear recommendation for your
            specific trip. Tell us where you're going, when, and how you like to travel. We'll
            tell you exactly what to buy.
          </p>
          <p className="text-neutral-400 mt-4">
            We're not trying to please everyone. We pick what we'd actually use, explain why,
            and let you decide if you agree. If you disagree, swap it out — we'll even show
            you alternatives.
          </p>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">Who's Behind This</h2>
          <p className="text-neutral-300 leading-relaxed">
            Built by someone who's spent too many hours reading gear forums, done the West Highland
            Way in sideways rain, and believes you shouldn't need to become a gear nerd just to
            go hiking.
          </p>
          <p className="text-neutral-400 mt-4">
            UK-focused (Scotland-heavy) because that's what we know best. Expanding to Alps,
            Scandinavia, and beyond because mountains are everywhere.
          </p>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">How We Make Money</h2>
          <p className="text-neutral-300 leading-relaxed">
            Affiliate links. When you buy gear through our links, we get a small commission.
            Same price for you, keeps the lights on for us.
          </p>
          <p className="text-neutral-400 mt-4">
            The crucial bit: affiliate commission rates never influence what we recommend.
            We pick the best product first, then link to retailers that stock it.
            Not the other way around.
          </p>
        </section>

        <section className="border-t border-neutral-800 pt-8">
          <p className="text-neutral-500 text-sm">
            Got feedback? Want to suggest a route or point out a better product?{' '}
            <a href="mailto:laurence@notfuckingabout.com" className="text-orange-500 hover:text-orange-400">
              laurence@notfuckingabout.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
